import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
 url: window._env_.REACT_APP_KEYCLOAK_URL,
 realm: window._env_.REACT_APP_KEYCLOAK_REALM,
 clientId: window._env_.REACT_APP_KEYCLOAK_ID,
})

export default keycloak;